import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IEventReportSlim, IResponse } from "../../Models";
import type { IEventReportsRepository } from "./IEventReportsRepository";

export default class EventReportsRepository implements IEventReportsRepository {
    public static $inject = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public get(): Observable<IResponse<IEventReportSlim[]>> {
        return this.httpService.get<IEventReportSlim[]>("eventReports");
    }
}

module("mmRepositories").service("mmEventReportsRepository", EventReportsRepository);
